var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slice',[_c('DirectoryListings',{attrs:{"clean":"","items":_vm.slice.items.map(function (a) { return a.item; })}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }